/** The Scorecards page. @public */
export const SCORECARDS_PATH = "/scorecards";

/** Path to an entity's Scorecard tab, opened at a category section when given. @public */
export function scorecardPath(
  ref: { kind?: string; namespace?: string; name: string },
  category?: string
): string {
  const ns = encodeURIComponent(ref.namespace ?? "default");
  const kind = encodeURIComponent(
    (ref.kind ?? "component").toLocaleLowerCase("en-US")
  );
  const path = `/catalog/${ns}/${kind}/${encodeURIComponent(
    ref.name
  )}/scorecard`;
  return category ? `${path}#${encodeURIComponent(category)}` : path;
}

/** The category a scorecardPath `#Category` anchor names, matched case-insensitively. @public */
export function categoryAnchorOf<C extends string>(
  hash: string,
  categories: ReadonlyArray<C>
): C | undefined {
  let name: string;
  try {
    name = decodeURIComponent(hash.replace(/^#/, ""));
  } catch {
    return undefined;
  }
  const wanted = name.trim().toLocaleLowerCase("en-US");
  return categories.find((c) => c.toLocaleLowerCase("en-US") === wanted);
}
